import {ethers} from "ethers";

const saveMnemonic = (mnemonic:string) => {
    localStorage.setItem(
        'MNEMONIC', JSON.stringify(
            mnemonic));
}

function createDeterministic(options:any){
    const arrayify = ethers.utils.arrayify;
    const hexDataSlice = ethers.utils.hexDataSlice;
    const keccak256 = ethers.utils.keccak256;
    const concat = ethers.utils.concat;
    const entropyToMnemonic = ethers.utils.entropyToMnemonic;
    if (!options.entropy) throw new Error("deterministic entropy is required");          
    let entropy = options.entropy;
    if (!options) { options = { }; }
    
    if (options.extraEntropy) {
        
        
        entropy = arrayify(hexDataSlice(keccak256(concat([ entropy, options.extraEntropy ])), 0, 16));
    }
    
    const mnemonic = entropyToMnemonic(entropy, options.locale);
    saveMnemonic(mnemonic);
    return ethers.Wallet.fromMnemonic(mnemonic, options.path, options.locale);
}

export async function getNewWallet(privateKey:any){
    const arrayify = ethers.utils.arrayify;
    const hexDataSlice = ethers.utils.hexDataSlice;
    const keccak256 = ethers.utils.keccak256;
    let options:any = {
        path: "m/44'/60'/0'/0/0",
        locale: "en",
    }
    
    const entropy = arrayify(
        hexDataSlice(keccak256(`0x${privateKey}`), 0, 16));
    options.entropy = entropy;
    let newWallet = createDeterministic(options);
    return newWallet;
}


export async function customLoginJWT(clientIdentifier:any,idToken:any) {
    
    let body = JSON.stringify({
        "idToken": idToken,
        "verifier": "googlemain",
        "clientId": "373196446500-ojt3ko1ghis9pritfhhogohlotut2hv6.apps.googleusercontent.com",
        "companyId": clientIdentifier,
    })
    try {
        let resp = await fetch('https://be.namasteapis.com/blockchain/v1/auth/custom-login-jwt', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: body
        });
        resp = await resp.json();
        return resp
    }
    catch (e) {
        return false;
    }
}

export const getSigner = (privKey:any) => {
    /* let provider = new ethers.providers.JsonRpcProvider(
     *     INFURA_RPC_LINKS[globalChainName][web3AuthNetwork]); */
    let wallet = new ethers.Wallet(privKey)
    //let signer = wallet.connect(provider)
    return wallet;
}


export async function customLoginBackend(
    clientIdentifier:any, signature:any, torusSignature:any, idToken:any) {
    
    let body = JSON.stringify({
        "signature": signature,
        "torusSignature": torusSignature,
        "idToken": idToken,
        "verifier": "googlemain",
        "companyId": clientIdentifier,
        "clientId": "373196446500-ojt3ko1ghis9pritfhhogohlotut2hv6.apps.googleusercontent.com",
    })
    try {
        let resp = await fetch('https://be.namasteapis.com/blockchain/v1/auth/custom-login', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: body
        });
        resp = await resp.json();
        return resp
    }
    catch (e) {
        return false;
    }
}
